import Service from '@ember/service';
import ENV from 'bullitttime-uploader/config/environment';

export default class RequestAjaxService extends Service
{
	host =  ENV.uploaderBackendProtocol+"://"+ENV.uploaderBackendHost+":"+ENV.uploaderBackendPort+(ENV.uploaderBackendNamespace ? "/"+ENV.uploaderBackendNamespace : "");

	request(url, options = {})
	{
		return fetch(this.host+url, options).then(function(response)
		{
			if(response.status === 204)
			{
				return null;
			}
			return response.json().then(function(json)
			{
				if(!response.ok)
				{
					const err = new Error(json && json.error ? json.error : 'request failed');
					err.status = response.status;
					throw err;
				}
				return json;
			});
		});
	};

	// Multipart POST helper for file uploads. The browser sets the
	// Content-Type (with boundary) automatically when we pass a FormData
	// body, so we deliberately don't set headers here.
	multipart(url, formData)
	{
		return this.request(url, { method: 'POST', body: formData });
	};
}